import { useMutation } from '@tanstack/react-query';
import { GET, GET_CLAIM_DETAIL } from '../../../../services';
import { useEffect, useState } from 'preact/hooks';

export const useGetClaimView = ({ claimCode, reset, getValues }) => {
  const [data, setData] = useState();
  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      const response = await GET(GET_CLAIM_DETAIL(claimCode));
      return response.result;
    },
    onSuccess: (result) => {
      reset({
        ...getValues(),
        ...result?.claim,
        claimImageUrl: [{ uid: result?.claim?.claimImageUrl, url: result?.claim?.claimImageUrl }],
        receiptImageUrl: [
          { uid: result?.claim?.receiptImageUrl, url: result?.claim?.receiptImageUrl },
        ],
      });
      setData(result);
    },
  });

  useEffect(() => {
    claimCode && mutate();
  }, [claimCode]);

  return { dataSource: data, loading: isPending };
};
